/*
Simple serialization; native engine optimization
Situation	Recommendation
You just need a quick clone of simple JSON-compatible data (no functions, dates, maps, etc.)
Use the lodash _.cloneDeep(), You need to reliably clone complex objects or preserve class types

But beware of limitations of JSON.parse(JSON.stringify(...)):
❌ Loses functions
❌ Loses undefined values
❌ Converts Date objects to strings
❌ Cannot clone circular references
❌ Breaks special classes like Map, Set, Buffer, etc.
 */

export function quickClone<T>(obj: T): T {
  //handle for undefined and null values
  if (obj === null || obj === undefined) {
    return obj
  }

  return JSON.parse(JSON.stringify(obj)) as T
}
